/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {Component, Input, ViewEncapsulation, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {FcResponsiveAgGridOptions} from './fc-responsive-ag-grid-options';

/**
 * Grid component with Angular.
 */
@Component({
    selector: 'fc-responsive-ag-grid-desktop',
    templateUrl: './fc-responsive-ag-grid-desktop.component.html',
    styleUrls: ['./fc-responsive-ag-grid-desktop.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcResponsiveAgGridDesktopComponent implements OnInit {

    /**
     * Fc Responsive Ag Grid Options.
     */
    @Input() gridOptions: FcResponsiveAgGridOptions;
    
    /**
     * Default constructor.
     */
    constructor() {
    }

    /**
     * Angular life cycle.
     */
    ngOnInit() {
        this.gridOptions.getNumberExtraRows = (): number[] => {
            if (this.gridOptions.gridState && this.gridOptions.data && this.gridOptions.data.length &&
                this.gridOptions.gridState.pageSize &&
                this.gridOptions.gridState.pageSize > this.gridOptions.data.length) {

                return _.range(0, this.gridOptions.gridState.pageSize - this.gridOptions.data.length);
            }
            return [];
        };
    }
}